import { useGetWorkspace } from '../serverState/workspace';
import { WorkspaceView } from '../types/WorkspaceView';
import { areViewsEqual } from '../components/TaskManagement/helpers/viewHelpers';
import { useViewContext } from '../pages/Space/Context/ViewContext';
import { updateWorkspaceView } from '../api/workspace';
import { queryClient } from '../queryClient';
import Workspace, { WorkspaceFramework } from '../types/Workspace';

export const useViewManagement = (activeView: WorkspaceView, onSaveForAllSuccess: () => void) => {
  const workspaceQuery = useGetWorkspace();
  const viewContext = useViewContext();

  const savedView = workspaceQuery.data?.Views.find((view) => view.id === Number(activeView.id));
  const isViewSelectedConfig = areViewsEqual(
    workspaceQuery.data?.framework || WorkspaceFramework.scrum,
    activeView,
    savedView
  );

  const resetToSavedView = async () => {
    if (savedView) {
      viewContext?.setView(savedView);
      viewContext?.setViews(viewContext.views.map((v) => (v.id === savedView.id ? savedView : v)));
      viewContext?.setViewDirty(false);
    }
  };

  const handleSaveViewForAll = async (view: WorkspaceView) => {
    viewContext?.setView(activeView);
    queryClient.setQueryData(['workspace', Number(activeView.workspaceId)], (oldData: Workspace) => {
      return {
        ...oldData,
        Views: oldData.Views.map((view) => {
          if (view.id === activeView.id) {
            return activeView;
          }
          return view;
        }),
      };
    });

    const res = await updateWorkspaceView(activeView.workspaceId, activeView.id, activeView);

    if (res.status === 200) {
      // Saved: the active view now matches the server, so a later viewUpdated may replace it.
      viewContext?.setViewDirty(false);
      onSaveForAllSuccess();
    }
  };

  return {
    isViewSelectedConfig,
    resetToSavedView,
    handleSaveViewForAll,
  };
};
